
import { X } from 'lucide-react';
import TopNavbar from '../components/TopNavbar';
import Lrn_us_sub from './lrn_us_sub';
import { Outlet } from 'react-router-dom';
const Learning = ( ) => {
 
  
    return (
        <div>
        <TopNavbar />
        <Lrn_us_sub /> 

        <Outlet />
           
    </div>
  );
};
 
export default Learning;